import { render, staticRenderFns } from "./ProformaInvoiceProducts.vue?vue&type=template&id=92532d0e"
import script from "./ProformaInvoiceProducts.vue?vue&type=script&lang=js"
export * from "./ProformaInvoiceProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports